import { render, staticRenderFns } from "./serviceTypeDialog.vue?vue&type=template&id=1bd559a2&scoped=true"
import script from "./serviceTypeDialog.vue?vue&type=script&lang=js"
export * from "./serviceTypeDialog.vue?vue&type=script&lang=js"
import style0 from "./serviceTypeDialog.vue?vue&type=style&index=0&id=1bd559a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd559a2",
  null
  
)

export default component.exports